import React, { ReactElement } from 'react';

import { LinkList } from './LinkList';
import { ListTitle } from './ListTitle';
import { IShopifyFooterSection } from './shopifyFooterSections';

interface ILinkSectionProps {
    section: IShopifyFooterSection;
}

export function LinkSection (props: ILinkSectionProps): ReactElement {
    const { section }: ILinkSectionProps = props;

    return (
        <ul className="list-none">
            <ListTitle>{section.title}</ListTitle>
            <LinkList links={section.links}/>
        </ul>
    );
}
